"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesContext = void 0;
var _PlantStateActivitiesController = require("./PlantStateActivitiesController");
var _Utils = require("../../../Utils");
/**
 * Provides a configured PlantStateActivites to consumers.
 * @component
 */

var PlantStateActivitiesContext = exports.PlantStateActivitiesContext = (0, _Utils.createEnhancedContext)({
  propName: "plantStateActivities",
  defaultController: _PlantStateActivitiesController.PlantStateActivitiesController
});